/**
 * Minimal profile fields (name/email/picture) cached locally so the UI
 * (TopNav, user menus, ShellLayout's chat greeting, etc.) can still display
 * "who's signed in" on origins where Auth0 SDK itself has no session — e.g.
 * a {slug}.{rootDomain} landed on via a cross-subdomain handoff (see
 * tokenHandoff.js). Auth0's own `user` object is scoped per-origin and is
 * `undefined` there even though our backend JWT is perfectly valid.
 *
 * This is a display-only cache — never treated as an authentication signal.
 */

const PROFILE_CACHE_KEY = 'aims_cached_profile';

/**
 * @param {{ name?: string, email?: string, picture?: string }|null|undefined} profile
 */
export function setCachedProfile(profile) {
  try {
    if (!profile) {
      localStorage.removeItem(PROFILE_CACHE_KEY);
      return;
    }
    const { name, email, picture } = profile;
    localStorage.setItem(PROFILE_CACHE_KEY, JSON.stringify({ name, email, picture }));
  } catch {
    // localStorage can throw in private mode — non-fatal, display just falls back.
  }
}

/**
 * @returns {{ name?: string, email?: string, picture?: string }|null}
 */
export function getCachedProfile() {
  try {
    const raw = localStorage.getItem(PROFILE_CACHE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearCachedProfile() {
  try {
    localStorage.removeItem(PROFILE_CACHE_KEY);
  } catch {
    // ignore
  }
}
